<template>
    <!-- section  -->	
    <section class="scroll-con-sec gray-bg" id="sec3" v-if="services.length">
        <div class="container">
            <div class="section-title fl-wrap">
                <h2>Services <strong>Provided</strong></h2>
                <div class="sec-title_dec"></div>
            </div>
            <div class="column-wrapper_text fl-wrap">
                <!-- serv-wrap-->
                <div class="serv-wrap fl-wrap">
                    <!-- serv-item -->
                    <div 
                        class="serv-item" 
                        :class="{ 'serv-item-right': index % 2 === 1 }"
                        v-for="(service, index) in services" 
                        :key="service.id"
                    >
                        <div class="serv-media">
                            <div class="bg" :data-bg="service.featured_image"></div>
                            <div class="team-info-num">{{ String(index + 1).padStart(2, '0') }}.</div>
                        </div>
                        <div class="serv-text" v-html="service.content"></div>
                    </div>
                    <!-- serv-item end -->
                </div>
                <!-- serv-wrap end -->
                <router-link to="/contact" class="btn float-btn">
                    <span>Get In Touch</span>
                </router-link>
            </div>
        </div>
        <div class="section-number"><span>0</span>2<strong>.</strong></div>
    </section>
    <!-- section end-->
</template>

<script>
export default {
    name: 'ServicesSection',
    data() {
        return {
            services: []
        }
    },
    async mounted() {
        await this.loadServices()
        
        // Process data-bg attributes after services are loaded
        this.$nextTick(() => {
            setTimeout(() => {
                this.processBackgrounds()
            }, 100)
        })
    },
    methods: {
        async loadServices() {
            try {
                const response = await this.$api.get('public/content/services')
                if (response.data && response.data.data) {
                    this.services = response.data.data
                }
            } catch (error) {
                console.error('❌ Failed to load services:', error)
            }
        },
        
        processBackgrounds() {
            const $ = window.jQuery
            
            if (!$) {
                console.warn('⚠️ jQuery not loaded')
                return
            }
            
            // Process data-bg attributes for service images
            $('.serv-media .bg[data-bg]').each(function() {
                const bg = $(this).attr('data-bg')
                if (bg) {
                    $(this).css('background-image', 'url(' + bg + ')')
                }
            })
            
            console.log('✅ Service backgrounds processed')
        }
    }
}
</script>

